const ModalType = {
  TOGGLE_ALERT_MODAL: "TOGGLE_ALERT_MODAL",
};
export default ModalType;
